import {
  QcmQuizAction,
  QcmQuizContainer,
  QcmQuizItems,
  QcmQuizItemSkip,
} from './QcmQuiz.styles';
import QcmQuizItem from '../QcmQuizItem';
import Button from 'components/Button';
import Paragraph from 'components/Typography/Paragraph';
import ContentWrapper from 'components/ContentWrapper';
import { QcmQuizItemType, QcmQuizProps } from './QcmQuiz.type';
import { useState } from 'react';
import ArrowsRight from 'Icons/ArrowsRight';
import Modal from 'components/Modal';
import QcmQuizPopup from '../QcmQuizPopup';
import Correct from 'assets/icons/Correct.png';
import Wrong from 'assets/icons/Wrong.png';
import { useTranslation } from 'react-i18next';

const QcmQuiz = ({
  question,
  avatar,
  items,
  correctAnswers,
  onSkip,
  onCorrect,
  onWrong,
  showCorrectAnswers = false,
}: QcmQuizProps): JSX.Element => {
  const { t } = useTranslation();
  const [data, setData] = useState<Array<QcmQuizItemType>>(items);
  const [disabledBtn, setDisbaledBtn] = useState<boolean>(true);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [quizState, setQuizState] = useState<boolean>(false);
  const [retry, setRetry] = useState<number>(1);

  // handle Change checkd items
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number,
  ) => {
    const newData = data.map((item: QcmQuizItemType, i: number) => {
      if (i === index) {
        setDisbaledBtn(false);
        return { ...item, checked: e.target.checked };
      }
      return item;
    });
    setData(newData);
  };

  //handle wrong answers
  const handleWrongAnswers = () => {
    onWrong && onWrong();
    onClose();
  };

  //Check good Answers
  const checkCorrectAnswers = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    e.preventDefault();
    let newData: Array<QcmQuizItemType> = [];
    const checkedAnswers = data.filter((item) => item.checked === true);
    const checkedAnswersTitles = checkedAnswers.map((item) => item.title);
    const isCorrect = checkedAnswersTitles.every((item) =>
      correctAnswers.includes(item),
    );
    if (showCorrectAnswers) {
      newData = data.map((item) => {
        if (correctAnswers.includes(item.title)) {
          return { ...item, correct: true };
        }
        if (checkedAnswersTitles.includes(item.title)) {
          return { ...item, correct: false };
        }
        return item;
      });
    }
    newData.length > 0 && setData(newData);

    setQuizState(isCorrect);
    setShowModal(true);
  };

  const onClose = () => {
    setShowModal(false);
  };

  const handleWrongAnswer = () => {
    // retry 2 times and show correct answer
    if (retry < 2) {
      setRetry(retry + 1);
      setShowModal(false);
      setQuizState(false);
    }
    if (retry === 2) {
      setQuizState(true);
      handleWrongAnswers();
    }
  };

  const handleCorrectAnswer = () => {
    onCorrect && onCorrect();
    onClose();
  };

  return (
    <ContentWrapper avatar={avatar} hasSpeechBox={true} text={question}>
      <QcmQuizContainer data-testid="QcmQuiz">
        <QcmQuizItems>
          {data.length > 0 &&
            data.map((item: any, index) => {
              return (
                item?.title && (
                  <QcmQuizItem
                    key={item.title}
                    {...item}
                    onChange={(e) => handleChange(e, index)}
                  />
                )
              );
            })}
        </QcmQuizItems>
        <QcmQuizAction>
          <Button
            rotation="-3.21deg"
            shadowColor="black"
            width="15rem"
            onClick={(e) => checkCorrectAnswers(e)}
            disabled={disabledBtn}
          >
            {t('continue')}
          </Button>
          <QcmQuizItemSkip onClick={onSkip}>
            <Paragraph>{t('skip')}</Paragraph>
            <ArrowsRight />
          </QcmQuizItemSkip>
        </QcmQuizAction>
      </QcmQuizContainer>
      <Modal isOpen={showModal} closeModal={onClose}>
        <QcmQuizPopup
          failed={retry === 2}
          title={quizState ? t('goodAnswers') : t('wrongAnswers')}
          status={quizState ? 'correct' : 'wrong'}
          image={quizState ? Correct : Wrong}
          onClose={onClose}
          description={retry === 2 ? correctAnswers?.toString() : ''}
          onButtonClick={quizState ? handleCorrectAnswer : handleWrongAnswer}
        />
      </Modal>
    </ContentWrapper>
  );
};

export default QcmQuiz;
